<template>
  <div class="home-wrapper">
    <app-header-curve></app-header-curve>
    <app-markets></app-markets>
    <app-overview></app-overview>
    <app-news></app-news>
  </div>
</template>

<script>
import HeaderCurve from "./shared/HeaderCurve";
import Markets from "./home/Markets";
import Overview from "./home/Overview";
import News from "./home/News";
export default {
  components: {
    appHeaderCurve: HeaderCurve,
    appMarkets: Markets,
    appOverview: Overview,
    appNews: News
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue